import "./index.css";
import "./i18n";

import { AuthProvider } from "./services/auth/CognitoAuthProvider.jsx";
import theme from "./services/ThemeService";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import React from "react";
import App from "./App.jsx";

theme.refresh();

const { DEV } = import.meta.env;

const isLocalhost = window.location.hostname === "localhost";

if (!isLocalhost) {
  Sentry.init({
    environment: DEV ? "development" : "production",
    dsn: "https://1d0c3bb3cf52bd85683c085d36ab3183@o4507429107662848.ingest.us.sentry.io/4507429110808576",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 0.1,
    tracePropagationTargets: ["localhost", /^https:\/\/api\.proof-online\.net/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export const proofCarousel = [
  { id: 1, title: "Intro to PROOF", videoUrl: "https://www.youtube.com/embed/q2YqqjcQvAE" },
  { id: 2, title: "Basic Neuroscience of PROOF", videoUrl: "https://www.youtube.com/embed/a0HcVz6dVn8" },
];


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);
